import React from "react";

export default function Terms() {
  return (
    <div>
      {/* Hero Header */}
      <div className="container-fluid bg-primary py-5 mb-5 hero-header">
        <div className="container py-5">
          <div className="row justify-content-center py-5">
            <div className="col-lg-10 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-3 text-white animated slideInDown">
                Terms & Conditions
              </h1>
              <p className="fs-4 text-white mb-4 animated slideInDown">
                Please review these terms before using our services.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Terms Content */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">

              <p className="mb-4">
                <strong>Last updated:</strong> December 24, 2025
              </p>

              <p className="mb-4">
                These Terms and Conditions (“Terms”) govern your access to and use of the
                website and services provided by <strong>The Outpost Gentlemen</strong>.
                By accessing our website or engaging our services, you agree to be bound
                by these Terms.
              </p>

              <h4 className="mt-5 mb-3">Use of Website</h4>
              <p className="mb-4">
                You agree to use this website for lawful purposes only and in a manner
                that does not infringe the rights of, restrict, or inhibit anyone else’s
                use and enjoyment of the website.
              </p>

              <h4 className="mt-5 mb-3">Services</h4>
              <p className="mb-4">
                The Outpost Gentlemen provides travel planning, consultation, and related
                services. All services are subject to availability and may be modified or
                discontinued at any time without notice.
              </p>

              <h4 className="mt-5 mb-3">Bookings & Appointments</h4>
              <p className="mb-4">
                Appointments scheduled through Calendly or other booking tools are
                subject to availability. We reserve the right to reschedule or cancel
                appointments with reasonable notice.
              </p>

              <h4 className="mt-5 mb-3">Payments & Fees</h4>
              <p className="mb-4">
                Fees for services, if applicable, will be disclosed prior to engagement.
                Payment terms, cancellation policies, and refunds (if any) will be
                communicated in writing before confirmation.
              </p>

              <h4 className="mt-5 mb-3">Intellectual Property</h4>
              <p className="mb-4">
                All content on this website, including text, graphics, logos, images, and
                design elements, is the property of The Outpost Gentlemen and may not be
                reproduced, distributed, or used without prior written consent.
              </p>

              <h4 className="mt-5 mb-3">Limitation of Liability</h4>
              <p className="mb-4">
                To the fullest extent permitted by law, The Outpost Gentlemen shall not
                be liable for any direct, indirect, incidental, or consequential damages
                arising from your use of this website or services.
              </p>

              <h4 className="mt-5 mb-3">Third-Party Links</h4>
              <p className="mb-4">
                This website may contain links to third-party websites. We are not
                responsible for the content, policies, or practices of those sites.
              </p>

              <h4 className="mt-5 mb-3">Termination</h4>
              <p className="mb-4">
                We reserve the right to terminate or restrict access to our website or
                services at our discretion, without notice, if these Terms are violated.
              </p>

              <h4 className="mt-5 mb-3">Governing Law</h4>
              <p className="mb-4">
                These Terms shall be governed by and construed in accordance with the
                laws of the applicable jurisdiction where The Outpost Gentlemen operates,
                without regard to conflict of law principles.
              </p>

              <h4 className="mt-5 mb-3">Changes to These Terms</h4>
              <p className="mb-4">
                We may update these Terms from time to time. Any changes will be posted
                on this page with an updated effective date.
              </p>

              <h4 className="mt-5 mb-3">Contact Us</h4>
              <p className="mb-1">
                <strong>The Outpost Gentlemen</strong>
              </p>
              <p className="mb-1">Email: info@theoutpostgentlemen.com</p>
              <p className="mb-4">Website: theoutpostgentlemen.com</p>

            </div>
          </div>
        </div>
      </div>
      {/* Terms Content End */}
    </div>
  );
}
